var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.848 13.7593H4.6485L5.27625 10.2071L8.59781 7.21519H5.77294L8.05725 5.81513H11.7714L6.96769 10.557L6.64481 12.3683C6.64481 12.3683 7.7175 12.447 8.56294 12.3683C9.40894 12.2811 10.359 11.9312 10.359 11.9312L7.848 13.7593ZM12.879 6.15656L11.4491 7.55662C11.4491 7.55662 12.6523 8.89537 11.5448 10.7325C10.4552 12.5347 6.83663 12.2023 6.83663 12.2023L7.11562 10.6189L12.2074 5.64919H7.9875L8.415 3.23438H6.37481L5.64244 7.36369H8.24062L5.15419 10.1464L4.5 13.8909C4.5 13.8909 6.96769 13.9607 9.06019 13.8909C11.1611 13.8206 13.6108 12.0184 13.9686 9.97988C14.4568 7.22363 12.879 6.15656 12.879 6.15656Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBze);
export default __webpack_public_path__ + "static/media/bze.99bf883d448ae42bc4d35ebff085cbd8.svg";
export { ForwardRef as ReactComponent };